"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var baseViewModel_1 = require("./base/baseViewModel");
var ko = require("knockout");
var ajaxUtils_1 = require("../../app/utils/ajaxUtils");
var ViewModel = (function (_super) {
    __extends(ViewModel, _super);
    function ViewModel(options) {
        var _this = this;
        _super.call(this, options);
        this.contestInfo = ko.observable({ activeCount: 0, displayCountAsNew: false });
        this.litmobInfo = ko.observable({ activeCount: 0, displayCountAsNew: false });
        ajaxUtils_1.AjaxUtils.get("utils/contestInfo", {}).done(function (result) {
            if (!result.isSuccessful) {
                return;
            }
            _this.contestInfo(result.data);
        });
        ajaxUtils_1.AjaxUtils.get("utils/litmobInfo", {}).done(function (result) {
            if (!result.isSuccessful) {
                return;
            }
            _this.litmobInfo(result.data);
        });
    }
    return ViewModel;
}(baseViewModel_1.default));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ViewModel;
//# sourceMappingURL=mobileLeftPanel.js.map